<template>
  <div class="wrap">
    <find-id-modal @closeModal="closeFindIdModal" v-if="findIdModalStatus" />
    <router-link to="/">
      <img class="logo" :src="require('@/assets/dver-logo.svg')" />
    </router-link>
    <FormulateInput
      type="text"
      v-model.trim="userId"
      placeholder="아이디"
      autofocus
      @blur="trimOnBlur()"
    />
    <FormulateInput
      type="password"
      v-model="password"
      placeholder="비밀번호"
      v-on:keyup.enter="signin"
    />
    <div v-if="!checkIdInput" class="error">아이디를 입력해 주세요.</div>
    <div v-if="!checkPasswordInput" class="error">
      비밀번호를 입력해 주세요.
    </div>
    <div v-if="isError" class="error">
      아이디와 비밀번호가 일치하지 않아요.😥
    </div>
    <div class="btn" v-if="!onProgress" @click="signin">로그인</div>
    <div class="btn" v-if="onProgress">
      <i class="far fa-spinner fa-spin fa-fw" />
    </div>
    <div class="bottom-wrap">
      <div class="join" @click="moveToJoin()">회원가입</div>
      <div class="find" @click="moveToFindUserInfo()">아이디/비밀번호 찾기</div>
    </div>
  </div>
</template>

<script>
import jwt from "jsonwebtoken";
import channelTalk from "@/helpers/channelTalk";
import { identifyUser } from "@/helpers/mixpanel";

export default {
  metaInfo: {
    title: "로그인",
  },
  mounted() {
    const data = this.$store.state.auth;
    const isAuthenticated = this.$store.getters["auth/isAuthenticated"]();
    if (data.accessToken && data.refreshToken) {
      if (!isAuthenticated) {
        this.$store.dispatch("auth/refreshSignin");
      }
      this.$router.push("/");
    }
  },
  methods: {
    trimOnBlur() {
      this.userId = this.userId.replace(/\s/g, "");
    },
    moveToFindUserInfo() {
      this.$router.push("/users/find-account");
    },
    moveToJoin() {
      this.$router.push("/join/intro");
    },

    async signin() {
      this.onProgress = true;
      (this.checkIdInput = true),
        (this.checkPasswordInput = true),
        (this.isError = false);
      if (!this.userId && !this.password) {
        this.onProgress = false;
        return;
      }
      if (!this.userId) {
        this.onProgress = false;
        this.checkIdInput = false;
        return;
      }
      if (!this.password) {
        this.onProgress = false;
        this.checkPasswordInput = false;
        return;
      }

      try {
        // apple
        if (localStorage.getItem("appleIsDeleted")) {
          alert("아이디 혹은 비밀번호 오류입니다");
          this.onProgress = false;
          return;
        }
        const result = await this.$store.dispatch("auth/signin", {
          userId: this.userId,
          password: this.password,
        });
        if (!result.success) {
          this.checkIdInput = true;
          this.checkPasswordInput = true;
          switch (result.code) {
            case 400:
              this.isError = true;
              break;
            case 404:
              this.isError = true;
              break;
            case 500:
              alert("서버에러가 발생하였습니다");
              break;
            default:
              alert("에러가 발생하였습니다");
              break;
          }
        } else {
          // apple
          if (this.userId === "apple") localStorage.setItem("isApple", "ok");

          const decoded = jwt.decode(result.accessToken);
          this.$store.dispatch("auth/updateAccessToken", result.accessToken);
          this.$store.dispatch("auth/updateRefreshToken", result.refreshToken);
          identifyUser(this.userId); // mixpanel id 등록
          await channelTalk.boot();
          const nextRouter = this.$route.query.router
            ? this.$route.query.router
            : "/";
          return this.$router.push(`${nextRouter}`);
        }
      } catch (error) {
        console.error(error);
        alert("서버에러가 발생하였습니다");
      }
      this.onProgress = false;
    },

    signup() {
      return alert("시범서비스 기간 중 신규 회원가입은 불가능합니다");
    },
  },
  data() {
    return {
      findIdModalStatus: false,
      validationErrors: [],
      onProgress: false,
      userId: "",
      password: "",
      isError: false,
      checkIdInput: true,
      checkPasswordInput: true,
    };
  },
};
</script>

<style src="./index.css" scoped></style>
